import { render, staticRenderFns } from "./EmailMessageForm.vue?vue&type=template&id=960e8030&"
import script from "./EmailMessageForm.vue?vue&type=script&lang=js&"
export * from "./EmailMessageForm.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports